
const customPortugueseMessages = {
  app: {
    toolbar:{
      features: "Funcionalidades"
    }  
  }
};
export default customPortugueseMessages;